import { render, staticRenderFns } from "./VuesticCard.vue?vue&type=template&id=f830b73e"
import script from "./VuesticCard.vue?vue&type=script&lang=js"
export * from "./VuesticCard.vue?vue&type=script&lang=js"
import style0 from "./VuesticCard.vue?vue&type=style&index=0&id=f830b73e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports